<template>
  <div id="app">
    <ksvuefp :options="options" :sections="sections">
      <ksvuefp-section v-for="(s,index) in sections" :section="s" :key="s.id" :section-index="index" :background-color="s.bgColor">
        <transition name="fade" :duration="400">
          <div class="page-section" v-if="$ksvuefp.currentIndex == index && !$ksvuefp.slidingActive">
            <page-section :section="s.title"></page-section>
          </div>
        </transition>
      </ksvuefp-section>
    </ksvuefp>
  </div>
</template>

<script>
import PageSection from './components/PageSection';

export default {
  name: 'app',
  components: {
    PageSection,
  },
  data() {
    return {
      sections: [
        {
          id: 1,
          bgColor: '#000',
          title: 'springter-section-1',
        },
        {
          id: 2,
          bgColor: '#fff',
          title: 'springter-section-2',
        },
        {
          id: 3,
          bgColor: '#00FFB8',
          title: 'springter-section-3',
        },
        {
          id: 4,
          bgColor: '#00FFB8',
          title: 'springter-section-4',
        },
        {
          id: 5,
          bgColor: '#fff',
          title: 'springter-section-5',
        },
        {
          id: 6,
          bgColor: '#fff',
          title: 'springter-section-6',
        },
        {
          id: 7,
          bgColor: '#fff',
          title: 'springter-section-7',
        },
        {
          id: 8,
          bgColor: '#00FFB8',
          title: 'springter-section-8',
        },
      ],
      options: {
        animationType: 'slideY',
        duration: 400,
        overlay: false,
        parallax: true,
        parallaxOffset: 0.5,
        currentIndex: 0,
      },
    };
  },
};
</script>

<style lang="scss" src="./main.scss"></style>


// WEBPACK FOOTER //
// src/App.vue